module.exports = __webpack_public_path__ + "static/media/in-progress.9ded5c82.svg";